import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const actions = {

    getGeneralStats(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/stats')
            .then((response) => {
                return response
            })
    },

    getInterventionWithoutContract(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/stats/interventions_without_contract', payload, options)
            .then((response) => {
                return response
            })
    },

    getInterventionsPoorlyPlanned(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/stats/interventions_poorly_planned', payload, options)
            .then((response) => {
                return response
            })
    },

    updateInterventionPoorlyPlanned(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/stats/interventions_poorly_planned/' + payload.intervention_id, payload, options)
            .then((response) => {
                return response
            })
    },

    deleteInterventions(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/stats/delete_interventions', payload, options)
            .then((response) => {
                return response
            })
    },

}

const getters = {
    list: state => state.list,
};

const sites = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default sites;
